<p>payment-popup works!</p>
